import { render, staticRenderFns } from "./GatewayMana.vue?vue&type=template&id=8836793a&scoped=true&"
import script from "./GatewayMana.vue?vue&type=script&lang=js&"
export * from "./GatewayMana.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8836793a",
  null
  
)

export default component.exports